import type { UseFormReturn } from "react-hook-form";
import type { StudentOnboardingFormInputs } from "./form-validation/full-form.schema";
import { Button } from "@shared-kernel/primary/shared/shadcn/ui/button";
import { Form } from "@shared-kernel/primary/shared/shadcn/ui/form";
import type { FormSubmit } from "@shared-kernel/primary/shared/api-errors/action-form";
import { ProfileStep } from "./subforms/student-onboarding.profile.subform";

interface Props {
  form: UseFormReturn<StudentOnboardingFormInputs>;
  onSubmit: FormSubmit;
  submitting: boolean;
}

export const StudentOnboarding = ({ form, onSubmit, submitting }: Props) => {
  return (
    <Form {...form}>
      <form onSubmit={onSubmit} className="space-y-6">
        <div className="space-y-2">
          <p className="text-sm text-muted-foreground">Renseignez votre nom de scène pour finaliser la création de votre profil élève.</p>
        </div>
        <ProfileStep />
        <div className="flex justify-end">
          <Button type="submit" disabled={submitting} className="w-full sm:w-auto">
            Confirmer
          </Button>
        </div>
      </form>
    </Form>
  );
};
